<div class="clients-header-container">
    <div>
        <h1>Reports</h1>
    </div>
    <div>
        <button (click)="loadAllItems(true)" [disabled]="loading || loadingAll" mat-raised-button color="primary">
            <mat-icon>sync</mat-icon>
            Load All
        </button>
        <button (click)="exportCsv()" [disabled]="loading || loadingAll" mat-raised-button color="accent">
            <mat-icon>file_download</mat-icon>
            Export to CSV
        </button>
    </div>
</div>

<div class="tiles">
    <div class="tile">
        <div class="tile-label">Members</div>
        <div class="tile-value">{{ totalMembers }}</div>
    </div>
    <div class="tile">
        <div class="tile-label">Total Premium</div>
        <div class="tile-value">{{ totalPremium | currency }}</div>
    </div>
    <div class="tile">
        <div class="tile-label">Enrolled</div>
        <div class="tile-value">{{ totalEnrolled }}</div>
    </div>
    <div class="tile">
        <div class="tile-label">Purchased</div>
        <div class="tile-value">{{ totalPurchased }}</div>
    </div>
    <div class="tile">
        <div class="tile-label">Lifetime Logins</div>
        <div class="tile-value">{{ totalLogins }}</div>
    </div>
</div>

<form class="filters" [formGroup]="form">
    <input class="search" #search matInput placeholder="Search by name, email, etc...">

    <mat-select class="partner" formControlName="team" name="team">
        <mat-option [value]="0">All Teams</mat-option>
        <mat-option *ngFor="let team of teams; let i = index" [value]="i + 1">{{ team.name }}</mat-option>
    </mat-select>

    <mat-select class="partner" formControlName="partner" name="partner">
        <mat-option [value]="0">All Partners</mat-option>
        <mat-option *ngFor="let partner of partners; let i = index" [value]="i + 1">{{ partner.name }}</mat-option>
    </mat-select>
</form>

<span *ngIf="items.data.length === 0 && !loading">No members match your search criteria.</span>

<div class="scroll-container" [hidden]="items.data.length === 0" (scroll)="onScroll($event)">
    <table class="table" mat-table matSort [dataSource]="items">

        <ng-container matColumnDef="partnerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
            <td class="cell" mat-cell *matCellDef="let item">{{item.partnerName}}</td>
        </ng-container>

        <ng-container matColumnDef="teamName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Team</th>
            <td class="cell" mat-cell *matCellDef="let item">{{item.teamName}}</td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td class="cell" mat-cell *matCellDef="let item">{{ item.firstName || '' }} {{ item.lastName || '' }}{{ item.email ? ' (' + item.email + ')' : '' }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Registered</th>
            <td class="cell" mat-cell *matCellDef="let item">{{ item.createdAt | date:'mediumDate' }}</td>
        </ng-container>

        <ng-container matColumnDef="lastLogin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
            <td class="cell" mat-cell *matCellDef="let item">{{ item.lastLoginDate | date:'mediumDate' }}</td>
        </ng-container>

        <ng-container matColumnDef="loginsTotalYearMonth">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total / Year / Month Logins</th>
            <td class="cell" mat-cell *matCellDef="let item">{{ item.lifetimeLoginCount || 0 }} / {{ item.thisYearLoginCount || 0 }} / {{ item.thisMonthLoginCount || 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="productsEnrolledPurchased">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Products Enrolled / Purchased</th>
            <td class="cell" mat-cell *matCellDef="let item">{{ item.activePostWithoutStripeCount || 0 }} / {{ item.stripeSubscriptionCount || 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="totalPremium">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Premium</th>
            <td class="cell" mat-cell *matCellDef="let item">{{ (item.totalMonthlyAmount || 0) | currency }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
        <tr class="listitem" mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
    </table>
</div>
